import { createReducer } from '@reduxjs/toolkit';
import { getDoctorInfo } from '../actions/getDoctor';

const initialState = {
  loading: true,
  data: {},
};
export default createReducer(initialState, (builder) => {
  builder.addCase(getDoctorInfo.fulfilled, (state, action) => ({
    ...state,
    data: action.payload,
    loading: false,
  })).addCase(getDoctorInfo.pending, (state) => ({
    ...state,
    loading: true,
  }));
});
